module.exports = __webpack_public_path__ + "img/img-10.8fc82189.svg";